// Minimal SVG flag components for the 5 supported UI languages.
// Using inline SVG rather than emoji (design system prohibits emoji) or a
// third-party library (5 flags don't justify the dependency).

function Flag({ children, className }: { children: React.ReactNode; className?: string | undefined }) {
  return (
    <svg
      viewBox="0 0 20 14"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
      style={{ display: 'block', borderRadius: 2, overflow: 'hidden' }}
    >
      {children}
    </svg>
  );
}

// 🇬🇧  Union Jack (simplified but recognisable)
export function FlagEN({ className }: { className?: string | undefined }) {
  return (
    <Flag className={className}>
      <rect width="20" height="14" fill="#012169" />
      {/* White diagonals */}
      <line x1="0" y1="0" x2="20" y2="14" stroke="white" strokeWidth="2.8" />
      <line x1="20" y1="0" x2="0" y2="14" stroke="white" strokeWidth="2.8" />
      {/* Red diagonals */}
      <line x1="0" y1="0" x2="20" y2="14" stroke="#C8102E" strokeWidth="1.4" />
      <line x1="20" y1="0" x2="0" y2="14" stroke="#C8102E" strokeWidth="1.4" />
      {/* White cross */}
      <rect x="8" y="0" width="4" height="14" fill="white" />
      <rect x="0" y="5" width="20" height="4" fill="white" />
      {/* Red cross */}
      <rect x="8.75" y="0" width="2.5" height="14" fill="#C8102E" />
      <rect x="0" y="5.75" width="20" height="2.5" fill="#C8102E" />
    </Flag>
  );
}

// 🇸🇪  Sweden — blue field, yellow Nordic cross
export function FlagSV({ className }: { className?: string | undefined }) {
  return (
    <Flag className={className}>
      <rect width="20" height="14" fill="#006AA7" />
      <rect x="6" y="0" width="3" height="14" fill="#FECC02" />
      <rect x="0" y="5.5" width="20" height="3" fill="#FECC02" />
    </Flag>
  );
}

// 🇳🇴  Norway — red field, blue-outlined white Nordic cross
export function FlagNO({ className }: { className?: string | undefined }) {
  return (
    <Flag className={className}>
      <rect width="20" height="14" fill="#EF2B2D" />
      {/* White cross */}
      <rect x="5.5" y="0" width="4" height="14" fill="white" />
      <rect x="0" y="5" width="20" height="4" fill="white" />
      {/* Blue cross (inset) */}
      <rect x="6.5" y="0" width="2" height="14" fill="#002868" />
      <rect x="0" y="6" width="20" height="2" fill="#002868" />
    </Flag>
  );
}

// 🇩🇰  Denmark — red field, white Nordic cross
export function FlagDA({ className }: { className?: string | undefined }) {
  return (
    <Flag className={className}>
      <rect width="20" height="14" fill="#C60C30" />
      <rect x="6" y="0" width="3" height="14" fill="white" />
      <rect x="0" y="5.5" width="20" height="3" fill="white" />
    </Flag>
  );
}

// 🇫🇮  Finland — white field, blue Nordic cross
export function FlagFI({ className }: { className?: string | undefined }) {
  return (
    <Flag className={className}>
      <rect width="20" height="14" fill="white" />
      <rect x="5" y="0" width="3.5" height="14" fill="#003580" />
      <rect x="0" y="5.25" width="20" height="3.5" fill="#003580" />
    </Flag>
  );
}
